export const profile = {
    'profile_account': 'الحساب',
    'profile_name': 'الاسم',
    'profile_email': 'البريد الإلكتروني',
    'profile_add_email': 'إضافة بريد إلكتروني',
    'profile_add_email_title': 'إضافة بريد إلكتروني',
    'profile_add_email_description': 'أدخل بريدك الإلكتروني وكلمة المرور. سنرسل رمز تحقق مكونا من 6 أرقام إلى هذا العنوان.',
    'profile_change_email': 'تغيير البريد الإلكتروني',
    'profile_change_email_title': 'تغيير البريد الإلكتروني',
    'profile_change_email_description': 'أدخل عنوان بريدك الإلكتروني الجديد وكلمة المرور. سنرسل رمز تحقق مكونا من 6 أرقام إلى العنوان الجديد وتنبيها أمنيا إلى العنوان الحالي.',
    'profile_change_email_error': 'حدث خطأ أثناء طلب تغيير البريد الإلكتروني',
    'profile_change_email_invalid_password': 'كلمة المرور الحالية غير صحيحة',
    'profile_change_email_same_email': 'يجب أن يكون البريد الإلكتروني الجديد مختلفا عن الحالي',
    'profile_change_email_verified': 'تم تحديث عنوان بريدك الإلكتروني. يرجى تسجيل الدخول مرة أخرى.',
    'profile_change_email_cancelled': 'تمت إزالة طلب تغيير البريد الإلكتروني المعلق.',
    'profile_change_email_discard_error': 'حدث خطأ أثناء إزالة طلب تغيير البريد الإلكتروني المعلق',
    'profile_pending_confirmation': 'بانتظار التأكيد',
    'profile_pending_email_hint': 'تحقق من بريدك الإلكتروني للعثور على رمز التحقق المكون من 6 أرقام.',
    'profile_pending_email_replace_hint': 'تحقق من بريدك الإلكتروني للعثور على رمز التحقق المكون من 6 أرقام. سيبقى بريدك الإلكتروني الحالي فعالاً حتى التأكيد.',
    'profile_change_phone': 'تغيير رقم الهاتف',
    'profile_change_phone_title': 'تغيير رقم الهاتف',
    'profile_change_phone_description': 'أدخل رقم هاتفك الجديد وكلمة المرور. سنرسل رمز تحقق مكونا من 6 أرقام عبر رسالة نصية إلى الرقم الجديد وتنبيها أمنيا إلى الرقم الحالي.',
    'profile_change_phone_error': 'حدث خطأ أثناء طلب تغيير رقم الهاتف',
    'profile_change_phone_invalid_password': 'كلمة المرور الحالية غير صحيحة',
    'profile_change_phone_same_phone': 'يجب أن يكون رقم الهاتف الجديد مختلفا عن الحالي',
    'profile_change_phone_exists': 'رقم الهاتف هذا مستخدم بالفعل من حساب آخر',
    'profile_change_phone_invalid_number': 'أدخل رقم هاتف صالحا',
    'profile_change_phone_verified': 'تم تحديث رقم هاتفك. يرجى تسجيل الدخول مرة أخرى.',
    'profile_change_phone_cancelled': 'تمت إزالة طلب تغيير رقم الهاتف المعلق.',
    'profile_change_phone_discard_error': 'حدث خطأ أثناء إزالة طلب تغيير رقم الهاتف المعلق',
    'profile_pending_phone_hint': 'تحقق من رسالة SMS للعثور على رمز التحقق المكون من 6 أرقام.',
    'profile_pending_phone_replace_hint': 'تحقق من رسالة SMS للعثور على رمز التحقق المكون من 6 أرقام. سيبقى رقم هاتفك الحالي فعالاً حتى التأكيد.',
    'profile_verification_code_step_description': 'أدخل رمز التحقق المكون من 6 أرقام الذي أرسلناه.',
    'profile_verification_code': 'رمز التحقق',
    'profile_verification_code_placeholder': 'رمز من 6 أرقام',
    'profile_verification_code_verify': 'تحقق',
    'profile_action_processing': 'جار المعالجة...',
    'profile_verification_code_resend': 'إعادة إرسال الرمز',
    'profile_verification_code_resend_in': 'إعادة إرسال الرمز خلال {{seconds}} ثانية',
    'profile_verification_code_expires_in': 'تنتهي صلاحية الرمز خلال حوالي {{minutes}} دقيقة.',
    'profile_verification_code_expired_hint': 'انتهت صلاحية هذا الرمز. اطلب رمزا جديدا.',
    'profile_verification_code_invalid': 'رمز التحقق غير صالح',
    'profile_verification_code_expired': 'انتهت صلاحية رمز التحقق هذا. اطلب رمزا جديدا.',
    'profile_verification_code_too_many_attempts': 'عدد كبير جدا من المحاولات الفاشلة. اطلب رمزا جديدا.',
    'profile_verification_code_resend_rate_limited': 'يرجى الانتظار قبل طلب رمز آخر.',
    'profile_change_email_code_description': 'أدخل رمز التحقق المكون من 6 أرقام الذي أرسل إلى {{value}}.',
    'profile_change_email_code_description_fallback': 'أدخل رمز التحقق المكون من 6 أرقام الذي أرسل إلى بريدك الإلكتروني.',
    'profile_change_phone_code_description': 'أدخل رمز التحقق المكون من 6 أرقام الذي أرسل إلى {{value}}.',
    'profile_change_phone_code_description_fallback': 'أدخل رمز التحقق المكون من 6 أرقام الذي أرسل إلى رقم هاتفك.',
    'profile_change_nickname': 'تغيير الاسم المستعار',
    'profile_change_nickname_title': 'تغيير الاسم المستعار',
    'profile_change_nickname_description': 'أدخل الاسم المستعار الجديد وكلمة المرور.',
    'profile_change_nickname_success': 'تم تحديث الاسم المستعار.',
    'profile_change_nickname_error': 'حدث خطأ أثناء تحديث الاسم المستعار',
    'profile_change_nickname_invalid_password': 'كلمة المرور الحالية غير صحيحة',
    'profile_change_nickname_same_nickname': 'يجب أن يكون الاسم المستعار الجديد مختلفا عن الحالي',
    'profile_change_password': 'تغيير كلمة المرور',
    'profile_password': 'كلمة المرور',
    'profile_phone': 'رقم الهاتف',
    'profile_add_phone': 'إضافة رقم هاتف',
    'profile_add_phone_title': 'إضافة رقم هاتف',
    'profile_add_phone_description': 'أدخل رقم هاتفك وكلمة المرور. سنرسل رمز تحقق مكونا من 6 أرقام عبر رسالة نصية إلى هذا الرقم.',
    'profile_not_provided': 'غير متوفر',
    'profile_study_info': 'معلومات الدراسة',
    'profile_view_consent': 'عرض الموافقة',
    'profile_opt_out': 'إلغاء الاشتراك',
    'profile_opt_out_message': 'هل تريد إنهاء الدراسة؟',
    'profile_allow_access_data': 'حفظ بياناتي بشكل مجهول',
    'profile_website': 'موقع البحث',
    'profile_contact': 'اتصل بالباحثين',
    'profile_report_bug': 'الإبلاغ عن خطأ',
    'profile_information_note': 'مذكرة المعلومات',
    'profile_download_pdf': 'تنزيل',
    'profile_download_pdf_loading': 'جارٍ التنزيل...',
    'profil_langue' : 'اللغة',
    'profile_pseudonym': 'الاسم المستعار',
}
